import React from 'react'
import { useTheme } from '@/hooks/useTheme'
import ControlReport from '@/components/reports/ControlReport'
import { FiltrosReporte } from '@/services/reportService'
import { format, startOfMonth, endOfMonth } from 'date-fns'

const ControlPage: React.FC = () => {
  const { colors } = useTheme()

  // Estado de filtros
  const [filtros, setFiltros] = React.useState<FiltrosReporte>({
    fecha_inicio: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
    fecha_fin: format(endOfMonth(new Date()), 'yyyy-MM-dd')
  })

  const [mostrarSoloProblemas, setMostrarSoloProblemas] = React.useState(false)
  const [refreshKey, setRefreshKey] = React.useState(0)

  const handleFechaPrincipio = (fecha: string) => {
    setFiltros((prev) => ({
      ...prev,
      fecha_inicio: fecha
    }))
  }

  const handleFechaFin = (fecha: string) => {
    setFiltros((prev) => ({
      ...prev,
      fecha_fin: fecha
    }))
  }

  const handleRefreshAll = () => {
    setRefreshKey((prev) => prev + 1)
  }

  const filtrosControl = {
    ...filtros,
    mostrar_solo_problemas: mostrarSoloProblemas
  }

  return (
    <div>
      {/* Título de la página */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Control</h1>
        <p className="text-gray-600 mt-2">
          Monitoreo jerárquico de reservas, pagos y documentos tributarios
        </p>
      </div>

      {/* Filtros */}
      <div className="mb-8">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {/* Fecha Inicio */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Fecha Inicio
              </label>
              <input
                type="date"
                value={filtros.fecha_inicio || ''}
                onChange={(e) => handleFechaPrincipio(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:outline-none transition-colors"
                style={{ '--tw-ring-color': colors.primary } as React.CSSProperties}
              />
            </div>

            {/* Fecha Fin */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Fecha Fin
              </label>
              <input
                type="date"
                value={filtros.fecha_fin || ''}
                onChange={(e) => handleFechaFin(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:outline-none transition-colors"
                style={{ '--tw-ring-color': colors.primary } as React.CSSProperties}
              />
            </div>

            {/* Checkbox: Solo mostrar problemas */}
            <div className="flex items-end">
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={mostrarSoloProblemas}
                  onChange={(e) => setMostrarSoloProblemas(e.target.checked)}
                  className="w-5 h-5 rounded border-gray-300 cursor-pointer"
                />
                <span className="ml-3 text-sm font-semibold text-gray-700">
                  ⚠️ Solo mostrar problemas
                </span>
              </label>
            </div>

            {/* Botón de actualizar - icono compacto */}
            <div className="flex items-end">
              <button
                onClick={handleRefreshAll}
                className="w-10 h-10 rounded-lg font-semibold transition-all flex items-center justify-center hover:opacity-90"
                style={{ backgroundColor: colors.primary, color: 'white' }}
                title="Actualizar datos"
              >
                🔄
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Reporte de Control */}
      <div key={`control-${refreshKey}`}>
        <ControlReport filtros={filtrosControl} onRefresh={handleRefreshAll} />
      </div>
    </div>
  )
}

export default ControlPage
